/**
 * 
 */
hrd.dashboard.openDashboard = function(url, params, options) {
	var deferred = $.Deferred();
	let innerDashboard;

	params = params || {};
	var defaults = {
		customId: undefined,
		modal: true,
		closable: true,
		resizable: false,
		draggable: false,
		minimizable: false,
		maximizable: false,
		ignoreNavParam: true,
		remoteCallbackInvocation: false,
		actionURI: false,
		innerArguments: [],
		hGap: 30,
		vGap: 15,
		rejectOnClose: false
	};
	options = $.extend(defaults, options);
	hrd.dashboard.openIFrameDialog(url, params, options, () => {
		if (deferred.state() == 'pending') {
			if (innerDashboard != undefined && typeof innerDashboard['provideDataOnClose'] === 'function') {
				let data = innerDashboard['provideDataOnClose'].apply(innerDashboard);
				if (options.rejectOnClose) {
					deferred.reject(data);
				} else {
					deferred.resolve(data);
				}
			} else {
				if (options.rejectOnClose) {
					deferred.reject();
				} else {
					deferred.resolve();
				}
			}
		}
	});

	const communicateWithInnerDashboard = (innerDashboard) => {
		// store in dahboard settings the 'customId', if available.
		innerDashboard.settings.customId = options.customId;

		//invokeMethod: function(dashletInstance, sMethod){
		if (options.parentDashlet != undefined) {
			let parentDashlet = options.parentDashlet;
			let parentDashboard = parentDashlet.dashboard;
			// aggiunge a questa dashboard la delega a chiamare il parent dashboard
			innerDashboard['invokeParentMethod'] = function(sMethod) {
				var params = [parentDashlet, sMethod].concat(Array.prototype.slice.call(arguments, 1));
				return parentDashboard._internalInvokeMethod_.apply(parentDashboard, params);
			}
		}
		
		if (typeof innerDashboard['provideAsynchData'] === 'function') {
			let promise = innerDashboard['provideAsynchData'].apply(innerDashboard, options.innerArguments);
			$.when(promise)
				.then(deferred.resolve, deferred.reject)
				.always(() => this.closeCurrentIFrameDialog(options.customId));
		} else {
			console.log(`You need to add "provideAsynchData" function to "${innerDashboard._FULL_}" in order to use "openDashboard" correctly`);
		}
	};

	const dialogFrameId = (options.customId != undefined) ? options.customId : 'dashboard-iframe';
	const dialogFrameIdSelector = `#${dialogFrameId}`;

	const $dialogFrameIdSelector = $(dialogFrameIdSelector);

	// verifico se la dialog non sia già presente, possibile sse ha customId
	innerDashboard = (options.customId != undefined) ? $dialogFrameIdSelector.get(0).contentWindow.dashboardInstance : undefined;

	if (innerDashboard != undefined && options.customId != undefined) {
		if (typeof innerDashboard['reInitDashboard'] === 'function') {
			innerDashboard['reInitDashboard'].apply(innerDashboard);
		} else {
			console.log(`You need to add "reInitDashboard" function to "${innerDashboard._FULL_}" in order to reuse "openDashboard" correctly`);
		}
		communicateWithInnerDashboard(innerDashboard);
	} else {
		$dialogFrameIdSelector
			.off('.dash')
			.one('load.dash', (evt) => {

				if($dialogFrameIdSelector.length > 0) {
					$dialogFrameIdSelector.contents().get(0).body.classList.add('in-dialog');
				}

				innerDashboard = evt.currentTarget.contentWindow.dashboardInstance;
				if (innerDashboard != undefined) {
					communicateWithInnerDashboard(innerDashboard);
				} else {
					console.log('The opened window does not contain a dashboard!')
				}
			});
	}

	return deferred.promise();
}